import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { UserRole } from './core/enums/user-role.enum';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./pages/project/projects.module').then((m) => m.ProjectsModule),
        canActivate: [authGuard]
    },
    {
        path: 'supervisor',
        loadChildren: () => import('./pages/project/projects.module').then((m) => m.ProjectsModule),
        canActivate: [authGuard, roleGuard],
        data: {
          allowedRoles: [UserRole.SUPERVISOR],
          redirectTo: '/dashboard'
        }
    },
    {
        path: 'analista',
        loadChildren: () => import('./pages/project/projects.module').then((m) => m.ProjectsModule),
        canActivate: [authGuard, roleGuard],
        data: {
          allowedRoles: [UserRole.ANALISTA],
          redirectTo: '/dashboard'
        }
    },
    {
        path:'comision',
        loadChildren: () => import('./pages/project/projects.module').then((m) => m.ProjectsModule),
        canActivate: [authGuard, roleGuard],
        data: {
          allowedRoles: [UserRole.COMISION],
          redirectTo: '/dashboard'
        }
    },
    {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full',
    },
];
